/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardCodeErrorResponse
 */
export interface RewardCodeErrorResponse {
    /**
     * Error message indicating why the code cannot be redeemed
     * @type {string}
     * @memberof RewardCodeErrorResponse
     */
    error?: RewardCodeErrorResponseErrorEnum;
}


/**
 * @export
 */
export const RewardCodeErrorResponseErrorEnum = {
    Used: 'used',
    Invalid: 'invalid'
} as const;
export type RewardCodeErrorResponseErrorEnum = typeof RewardCodeErrorResponseErrorEnum[keyof typeof RewardCodeErrorResponseErrorEnum];


/**
 * Check if a given object implements the RewardCodeErrorResponse interface.
 */
export function instanceOfRewardCodeErrorResponse(value: object): value is RewardCodeErrorResponse {
    let isInstance = true;

    return isInstance;
}

export function RewardCodeErrorResponseFromJSON(json: any): RewardCodeErrorResponse {
    return RewardCodeErrorResponseFromJSONTyped(json, false);
}

export function RewardCodeErrorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardCodeErrorResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RewardCodeErrorResponseToJSON(value?: RewardCodeErrorResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': value.error,
    };
}

